import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getUsersUrl = (companyId) => `/companies/${companyId}/users`;

const addUserUrl = (companyId) => `/companies/${companyId}/users`;

const getByIdUrl = (companyId, userId) => `/companies/${companyId}/users/${userId}`;

const updateUserUrl = (companyId, userId) => `/companies/${companyId}/users/${userId}`;

const toggleUserUrl = (companyId, userId) => `/companies/${companyId}/users/${userId}/toggle`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  getUsers(companyId, filters, limit, page, orderBy, order) {
    const url = getUsersUrl(companyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getUserById(companyId, userId) {
    const url = getByIdUrl(companyId, userId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  addUser(companyId, data) {
    const url = addUserUrl(companyId);
    return this.axios
      .post(url, data, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  updateUser(companyId, userId, data) {
    const url = updateUserUrl(companyId, userId);
    return this.axios
      .put(url, data, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggleUser(companyId, userId) {
    const url = toggleUserUrl(companyId, userId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/users.api.js